// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"b5f57ede","296":"f1ab3664","787":"cc7a1eb8"}[chunkId] + ".chunk.js";
};